export default "__VITE_ASSET__BKy8RqWn__"